import FFieldMDP from "@/components/form/field/FFieldMDP";
import { FFormChildMDP } from "@/components/form/FFormMDP";

export default class FSwitchMDP implements FFieldMDP {
  componentName = "FSwitch";
  dataSelectorKey: string;
  label: string;
  rules: string;
  mandatory: boolean;
  parentMDP: FFormChildMDP;
  boundaryClass?: string;
  disabled: boolean;
  inset?: boolean;
  falseValue: boolean
  trueValue: boolean
  onChange?: (item: boolean) => void;

  constructor({
    parentMDP,
    dataSelectorKey,
    label,
    rules = "",
    mandatory = false,
    boundaryClass,
    disabled = false,
    inset = true,
    falseValue = false,
    trueValue = true,
    onChange
  }: {
    parentMDP: FFormChildMDP;
    dataSelectorKey: string;
    label: string;
    rules?: string;
    mandatory?: boolean;
    boundaryClass?: string;
    disabled?: boolean;
    inset?: boolean;
    falseValue? : boolean;
    trueValue? : boolean;
    onChange?: (item: boolean) => void;
  }) {
    this.parentMDP = parentMDP;
    this.dataSelectorKey = dataSelectorKey;
    this.label = label;
    this.rules = rules;
    this.mandatory = mandatory;
    this.boundaryClass = boundaryClass;
    this.disabled = disabled;
    this.inset = inset;
    this.falseValue = falseValue;
    this.trueValue = trueValue;
    this.onChange = onChange;
  }

  getRules() {
    const required = this.mandatory ? "required" : "";
    return `${required}|${this.rules}`;
  }

  getBoundaryClass() {
    return `${this.boundaryClass?this.boundaryClass: this.parentMDP.boundaryClass} py-0 px-2`;
  }

  getMetaData(): object {
    return {
      componentName: this.componentName,
      dataSelectorKey: this.dataSelectorKey,
      rules: this.getRules(),
      boundaryClass: this.getBoundaryClass(),
      props: {
        id: this.dataSelectorKey,
        label: this.label,
        outlined: this.parentMDP.outlined,
        dense: this.parentMDP.dense,
        disabled: this.disabled,
        inset: this.inset,
        falseValue: this.falseValue,
        trueValue: this.trueValue,
        onChange: this.onChange
      },
    };
  }
}
